@if (showHeader) {
  <rask-header>
    <ng-content select="[header]"></ng-content>
  </rask-header>
}

<div class="block-body">
  <ng-content></ng-content>
</div>
@if (showFooter) {
  <footer #footer>
    <ng-content select="[footer]"></ng-content>
  </footer>
}
